import { Injectable, Signal } from '@angular/core';
import { IPersonaData, IPersonaModel } from '@partners/api';
import { Observable } from 'rxjs';
import { StateAccessService } from '../../../services';
import { IPersonaState, PersonaActions, PersonaSelectors } from '../store';

@Injectable({
  providedIn: 'root'
})
export class PersonaStore extends StateAccessService<IPersonaState> {
  readonly state$: Observable<IPersonaState>;

  readonly data$$: Signal<IPersonaData>;
  readonly model$$: Signal<IPersonaModel>;

  constructor() {
    super();

    this.model$$ = this.stateFacade.selectSignal$(PersonaSelectors.model);
    this.data$$ = this.stateFacade.selectSignal$(PersonaSelectors.data);
  }

  dispatchPersonaReset() {
    this.stateFacade.dispatch(PersonaActions.reset());
  }
  dispatchPersonaLoad() {
    this.stateFacade.dispatch(PersonaActions.load());
  }
  dispatchPersonaLoadSuccess({ model, data }: { model: IPersonaModel; data: IPersonaData }) {
    this.stateFacade.dispatch(PersonaActions.loadSuccess({ model, data }));
  }
  dispatchPersonaSubmit() {
    this.stateFacade.dispatch(PersonaActions.submit());
  }
  dispatchPersonaSubmitSuccess({ model, data }: { model: IPersonaModel; data: IPersonaData }) {
    this.stateFacade.dispatch(PersonaActions.submitSuccess({ model, data }));
  }
}
